import { z } from "zod";

export const PROJECT_FILE_MAX_BYTES = 131072;
const filePath = z.string().min(1).max(500);
const hash = z.string().regex(/^[a-f0-9]{64}$/);
const content = z.string().max(PROJECT_FILE_MAX_BYTES).refine(value => !value.includes("\0") && value.isWellFormed() && new TextEncoder().encode(value).length <= PROJECT_FILE_MAX_BYTES);
export const projectFileKindSchema = z.enum(["TEXT", "MD", "ENV", "CODE"]);
export const projectFileOperationRequestSchema = z.discriminatedUnion("operation", [
  z.object({ operation: z.literal("list") }).strict(),
  z.object({ operation: z.literal("read"), path: filePath }).strict(),
  z.object({ operation: z.literal("write"), path: filePath, content, expected_sha256: hash.nullable() }).strict(),
  z.object({ operation: z.literal("delete"), path: filePath, expected_sha256: hash }).strict(),
]);
export type ProjectFileOperationRequest = z.infer<typeof projectFileOperationRequestSchema>;
export const projectFileOperationResultSchema = z.discriminatedUnion("operation", [
  z.object({ operation: z.literal("list"), files: z.array(z.object({ path: filePath, kind: projectFileKindSchema }).strict()).max(2000), truncated: z.boolean().default(false), capabilities: z.object({ allowCreate: z.boolean(), allowUpdates: z.boolean(), allowDeletes: z.boolean(), reason: z.enum(["external_writer_exclusion_unavailable"]).nullable() }).strict().optional() }).strict(),
  z.object({ operation: z.literal("read"), path: filePath, kind: projectFileKindSchema, content, sha256: hash }).strict(),
  z.object({ operation: z.literal("write"), path: filePath, sha256: hash }).strict(),
  z.object({ operation: z.literal("delete"), path: filePath }).strict(),
]);
export type ProjectFileOperationResult = z.infer<typeof projectFileOperationResultSchema>;
export const projectFileOperationResponseSchema = z.object({
  id: z.uuid(), project_id: z.uuid(), state: z.enum(["pending", "succeeded", "failed", "unknown"]),
  result: projectFileOperationResultSchema.nullable(), error: z.string().max(120).nullable(),
  created_at: z.iso.datetime(), settled_at: z.iso.datetime().nullable(),
}).strict();
export type ProjectFileOperationResponse = z.infer<typeof projectFileOperationResponseSchema>;
